export const footballFilteringOptions = {
  Table: {
    name: 'Tabela',
    value: 'table',
    options: [
      {
        name: 'Ogólna',
        value: 'all',
        options: []
      },
      {
        name: 'Forma',
        value: 'form',
        options: []
      },
      {
        name: 'Po X Kolejce',
        value: 'rounds',
        options: []
      },
    ]
  },
  Corners: {
    name: 'Rożne',
    value: 'corners',
    options: [
      {
        name: 'Rezultat',
        value: 'result',
        options: []
      },
      {
        name: 'Over/Under',
        value: 'overunder',
        options: [
          {
            name: '7,5',
            value: 7.5,
            options: []
          },
          {
            name: '8,5',
            value: 8.5,
            options: []
          },
          {
            name: '9,5',
            value: 9.5,
            options: []
          },
          {
            name: '10,5',
            value: 10.5,
            options: []
          },
          {
            name: '11,5',
            value: 11.5,
            options: []
          },
          {
            name: '12,5',
            value: 12.5,
            options: []
          },
        ]
      }
    ]
  },
  Cards: {
    name: 'Kartki',
    value: 'cards',
    options: [
      {
        name: 'Żółte',
        value: 'yellow',
        options: [
          {
            name: 'Rezultat',
            value: 'result',
            options: [],
          },
          {
            name: 'Over/Under',
            value: 'overunder',
            options: [
              {
                name: '1,5',
                value: 1.5,
                options: []
              },
              {
                name: '2,5',
                value: 2.5,
                options: []
              },
              {
                name: '3,5',
                value: 3.5,
                options: []
              },
              {
                name: '4,5',
                value: 4.5,
                options: []
              },
              {
                name: '5,5',
                value: 5.5,
                options: []
              },
            ],
          },
        ],
      },
      {
        name: 'Czerwone',
        value: 'red',
        options: [
          {
            name: 'Rezultat',
            value: 'result',
            options: [],
          },
          {
            name: 'Over/Under',
            value: 'overunder',
            options: [
              {
                name: '0,5',
                value: 0.5,
                options: []
              },
            ],
          },
        ],
      },
    ]
  },
  BTTS: {
    name: 'BTTS',
    value: 'btts',
    options: []
  },
  OverUnder: {
    name: 'Over/under',
    value: 'overunder',
    options: [
      {
        name: '0,5',
        value: 0.5,
        options: []
      },
      {
        name: '1,5',
        value: 1.5,
        options: []
      },
      {
        name: '2,5',
        value: 2.5,
        options: []
      },
      {
        name: '3,5',
        value: 3.5,
        options: []
      },
      {
        name: '4,5',
        value: 4.5,
        options: []
      },
      {
        name: '5,5',
        value: 5.5,
        options: []
      },
    ]
  },
  Halves: {
    name: 'Połowy',
    value: 'halfs',
    options: [
      {
        name: '1. Połowa',
        value: 'firsthalf',
        options: []
      },
      {
        name: '2. Połowa',
        value: 'secondhalf',
        options: []
      },
    ]
  },
  HtFt: {
    name: 'HT/FT',
    value: 'htft',
    options: []
  },
  CleanSheets: {
    name: 'Czyste konto',
    value: 'cleansheet',
    options: []
  },
  Penalties: {
    name: 'Karne',
    value: 'penalty',
    options: [
	    {
		    name: 'Gole Z Karnych',
		    value: 'inmatch',
		    options: []
	    },
    ]
  },
  Quarters: {
    name: 'Kwadranse',
    value: 'quarters',
    options: [
      {
        name: 'Ogółem',
        value: 'all',
        options: []
      },
      {
        name: 'Zdobyte',
        value: 'obtained',
        options: []
      },
      {
        name: 'Stracone',
        value: 'lost',
        options: []
      }
    ]
  },
  Odds: {
		name: 'Kursy',
		value: 'odds',
		options: [
      {
        name: '1x2',
        value: '1x2',
        options: [],
      },
      {
        name: 'win & lose',
        value: 'winLose',
        options: [],
      },
    ]
  },
  BallPossesion: {
    name: 'Posiadanie',
    value: 'possesion',
    options: []
  },
  Shots: {
    name: 'Strzały',
    value: 'shots',
    options: []
  },
  Offsides: {
    name: 'Spalone',
    value: 'offsides',
    options: [
      {
        name: 'Rezultat',
        value: 'result',
        options: [],
      },
      {
        name: 'Over/Under',
        value: 'overunder',
        options: [
          {
            name: '0,5',
            value: 0.5,
            options: []
          },
          {
            name: '1,5',
            value: 1.5,
            options: []
          },
          {
            name: '2,5',
            value: 2.5,
            options: []
          },
          {
            name: '3,5',
            value: 3.5,
            options: []
          },
          {
            name: '4,5',
            value: 4.5,
            options: []
          },
        ],
      },
    ],
  },
  Fouls: {
    name: 'Faule',
    value: 'fouls',
    options: []
  },
  Passes: {
    name: 'Podania',
    value: 'passes',
    options: []
  }
}

export function resetOptionsFor(obj, key) {
  if (obj[key] && obj[key].hasOwnProperty('options')) {
    obj[key].options = [];
  }
}

export function setOptionsFor(obj, key, options) {
  if (obj[key] && obj[key].hasOwnProperty('options')) {
    obj[key].options = options;
  }
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}